export const regExpLowercase = /[a-z]/;
export const regExpUppercase = /[A-Z]/;
export const regExpNumber = /[0-9]/;
export const regExpSpecial = /[^a-zA-Z\d\s:]/;
export const regExpNonASCIIcharacters = /^[ -~]+$/;
